import api from "../../plugins/api";

const generateContractBlank = ({ orderIds, documentTypeId }) => {
  return api.post('/api/bucket/generateContractBlank', { orderIds, documentTypeId });
};

export default generateContractBlank;
